import { memo, VFC, useEffect, useState } from 'react';
import {
  Table,Thead,Tbody,Tr,Th,Td,
  Box,Flex,Text,
} from '@chakra-ui/react';
import { ListButton } from '../atoms/button/ListButton';
import { MyText } from '../atoms/text/MyText';
import { getIssueGroupResult, issueGroupObj } from '../../types/issue';

type Props = {
  getIssueGroupResult: getIssueGroupResult;
  setIssueArn: (issueArn:string)=>void;
};

export const IssueGroupTable: VFC<Props> = memo((props) => {
  const { getIssueGroupResult, setIssueArn } = props;
  const [ failList, setFailList ] = useState<Array<issueGroupObj>>([]);
  const [ failListNum, setFailListNum ] = useState(0);

  useEffect(() => {
    if( getIssueGroupResult ){
      setFailList(getIssueGroupResult.aws_fail_list ?? []);
      setFailListNum(getIssueGroupResult.aws_fail_list.length);
    }
  }, [getIssueGroupResult]);
  
  return (
    <>
      {getIssueGroupResult && (
        <Box id="report">
          <Flex alignItems="flex-end">
              <Text fontSize="lg">
                ■障害一覧（{failListNum}件）
              </Text>
          </Flex>
          {/* 以下障害グループ詳細リスト */}
          <Table id="table-health-group-detail" border="1" colorScheme="gray" variant="striped" size="xs">
            <Thead background="#aaaaaa">
              <Tr>
                <Th width="10px" color="white" fontSize="sm">No.</Th>
                <Th width="20%" color="white" fontSize="sm">開始日時</Th>
                <Th width="20%" color="white" fontSize="sm">終了日時</Th>
                <Th width="15%" color="white" fontSize="sm">リージョン</Th>
                <Th color="white" fontSize="sm">サービス</Th>
                <Th width="15%" color="white" fontSize="sm">種別</Th>
                <Th width="5%" color="white" fontSize="sm"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {failList.map((item:issueGroupObj,index) => (
                <Tr key={index}>
                  <Td>{index+1}</Td>
                  <Td><MyText size='xs' str={item.start_time} /></Td>
                  <Td><MyText size='xs' str={item.end_time} /></Td>
                  <Td><MyText size='xs' str={item.region_name} /></Td>
                  <Td><MyText size='xs' str={item.service_name} /></Td>
                  <Td><MyText size='xs' str={item.health_kind} /></Td>
                  <Td>
                    <ListButton onClick={()=>setIssueArn(item.health_arn)}>詳細</ListButton>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
    </>
  );
});
